import { EntityCoreBase } from "./entity.core.base"


export class EntityCore extends EntityCoreBase {

}